import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "@babel/runtime/helpers/esm/typeof";
// @ts-nocheck
import { parseUserPathExtra } from "../../../funnel";
import { config, getAttr, getContentParam, getDomConfig, getDomParam, getDPosDom, getSpmCPos, getSpmDPos, ownAddEventListener } from "../../../utils";
var spmAbTest = 'data-aspm-ab';
var spmEntityid = 'data-aspm-entityid';

// 点击事件监听
function spmEventHandler(event) {
  var _Tracert$spmConfig, _Tracert$spmConfig$pa, _Tracert$spmConfig$pa2, _clickSpmOptions$spmI, _clickSpmOptions$spmI2;
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  var Tracert = this;
  var el = event.target || event.srcElement;
  var clickSpmOptions = Tracert.getClickSpm(el);
  var isSeed = /^c|^d/.test(clickSpmOptions.spmId);
  var _spmId = clickSpmOptions.spmId;
  clickSpmOptions.spmId = isSeed ? clickSpmOptions === null || clickSpmOptions === void 0 ? void 0 : clickSpmOptions.spmId : Tracert === null || Tracert === void 0 ? void 0 : (_Tracert$spmConfig = Tracert.spmConfig) === null || _Tracert$spmConfig === void 0 ? void 0 : (_Tracert$spmConfig$pa = _Tracert$spmConfig.pages) === null || _Tracert$spmConfig$pa === void 0 ? void 0 : (_Tracert$spmConfig$pa2 = _Tracert$spmConfig$pa[Tracert === null || Tracert === void 0 ? void 0 : Tracert.currentPage]) === null || _Tracert$spmConfig$pa2 === void 0 ? void 0 : _Tracert$spmConfig$pa2[clickSpmOptions === null || clickSpmOptions === void 0 ? void 0 : (_clickSpmOptions$spmI = clickSpmOptions.spmId) === null || _clickSpmOptions$spmI === void 0 ? void 0 : (_clickSpmOptions$spmI2 = _clickSpmOptions$spmI.split('.')) === null || _clickSpmOptions$spmI2 === void 0 ? void 0 : _clickSpmOptions$spmI2[1]];
  if (!clickSpmOptions.spmId) {
    clickSpmOptions.spmId = _spmId;
  }
  // spm点击
  if (_typeof(clickSpmOptions) === 'object' && clickSpmOptions.spmId) {
    var _clickSpmOptions$spmI3, _clickSpmOptions$spmI4, _clickSpmOptions$spmI5;
    var dom = clickSpmOptions.dom;
    var externOpts = {};
    // 注入扩展abtest和数据回流参数
    if (getAttr(dom, spmAbTest)) {
      externOpts.abTest = true;
    }
    // 注入扩展abtest和数据回流参数
    if (getAttr(dom, spmEntityid)) {
      externOpts.entityId = getAttr(dom, spmEntityid);
    }
    // 加入内容埋点参数
    var contentParams = getContentParam(dom);
    if (contentParams && contentParams.param5) {
      externOpts.param5 = contentParams.param5;
      externOpts.newScm = contentParams.newScm;
    }
    var currentConfig = getDomConfig(dom) || {};
    var extra = _objectSpread(_objectSpread({}, parseUserPathExtra("click_".concat((_clickSpmOptions$spmI3 = clickSpmOptions.spmId) === null || _clickSpmOptions$spmI3 === void 0 ? void 0 : (_clickSpmOptions$spmI4 = _clickSpmOptions$spmI3.split) === null || _clickSpmOptions$spmI4 === void 0 ? void 0 : (_clickSpmOptions$spmI5 = _clickSpmOptions$spmI4.call(_clickSpmOptions$spmI3, '.')) === null || _clickSpmOptions$spmI5 === void 0 ? void 0 : _clickSpmOptions$spmI5.pop()))), getDomParam(dom));
    Tracert.call('click', clickSpmOptions.spmId, extra, externOpts, _objectSpread({
      combineType: config.COMBINE_TYPE.MIX,
      event: event
    }, currentConfig));
    return;
  }
}
var autoClick = {
  spmClickEvent: function spmClickEvent(nextEventType) {
    var _this = this,
      _window;
    var eventType = nextEventType || this.eventType;

    // 事件名为空，返回
    if (!eventType) {
      return;
    }

    // 移除原来的监听事件
    if (typeof this._clickEventDisposer === 'function') {
      this._clickEventDisposer();
    }
    var cFunc = function cFunc(e) {
      var breforeResult = _this._runBeforeFns('autoClick', e);
      if (breforeResult === false) {
        return;
      }
      spmEventHandler.call(_this, e);
    };
    this._clickEventDisposer = ownAddEventListener(eventType, this.container || ((_window = window) === null || _window === void 0 ? void 0 : _window.document), cFunc);
    this.call('addSideEffects', this._clickEventDisposer);
  },
  _spmEventHandler: spmEventHandler,
  getClickSpm: function getClickSpm(el) {
    var dom = getDPosDom(el);
    var spmDPos = getSpmDPos(dom);
    var result = {
      dom: dom,
      spmId: ''
    };
    if (!this.spmAPos || !this.spmBPos) {
      return result;
    }
    if (dom && spmDPos) {
      var spmIdList = spmDPos.split('.');
      var spmIdListlen = spmIdList.length;
      var spmCPos = '';
      if (spmIdListlen === 1) {
        spmCPos = getSpmCPos(dom);
        if (spmCPos) {
          spmIdList.unshift(spmCPos);
        } else {
          return result;
        }
      }
      // a.b.c 不支持
      if (spmIdListlen === 3) {
        return result;
      }
      result.spmId = spmIdList.join('.');
    }
    return result;
  }
};
export default autoClick;